'use client'

import { Image } from '@vinted/web-ui'

import { UserImage } from '@marketplace-web/shared/ui-helpers'
import { findThumbnail } from '@marketplace-web/shared/utils'
import { UserPhotoModel } from '@marketplace-web/shared/user-data'
import { conversationUserProfileIconClick } from '_libs/common/event-tracker/events'
import { useConversationContext } from '@marketplace-web/domain/core-conversation'
import { useTracking } from '@marketplace-web/shared/event-tracker'

type Props = {
  isSystem: boolean
  isCurrentAuthor?: boolean
  photo: UserPhotoModel | null
  profileUrl: string
  alt?: string
}

const UserPhoto = ({ isSystem, isCurrentAuthor = false, photo, profileUrl, alt }: Props) => {
  const { conversation } = useConversationContext()
  const { track } = useTracking()
  const userThumbnailUrl = findThumbnail(photo)

  const userImage = (
    <UserImage
      src={userThumbnailUrl}
      isSystem={isSystem}
      size={Image.Size.Medium}
      styling={Image.Styling.Circle}
      alt={alt}
      testId="user-photo"
    />
  )

  const handleUserPhotoClick = () => {
    if (!conversation?.id || !conversation?.transactionId) return

    track(
      conversationUserProfileIconClick({
        conversationId: conversation.id,
        transactionId: conversation.transactionId,
      }),
    )
  }

  if (isCurrentAuthor) return null

  return profileUrl ? (
    <a href={profileUrl} onClick={handleUserPhotoClick}>
      {userImage}
    </a>
  ) : (
    userImage
  )
}

export default UserPhoto
